import React, { useEffect, useState } from "react";
import "../styles/transaction.css";
import "../styles/common.css";
import my_profile123 from "../images/my_profile/personel_details.svg";
import pen from "../images/my_profile/pen.svg";
import view from "../images/my_profile/eye.svg";
import moment from "moment";
import SelectDropDown from "./SelectDropDown";
import calendar_month from "../images/my_profile/calendar_month.svg";
import DatePickerInput from "./DatePickerInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../styles/profile.css";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeInput } from "../utils/sanitizeInput";
import { getLocalStorageUserData } from "../utils/userData";
import {
  pincode,
  userPofileStore,
  userPofileUpdate,
} from "../actions/usersActions";
import {
  convertDateToDDMMMYYYY,
  convertDateToDDMMMYYYYLetter,
  convertDateToDDMMYYYY,
  convertDateToDDMMYYYYStartWithYear,
} from "../utils/DateFormate";

const PersonelDetail = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { userGetProfile } = useSelector((state) => state.users);
  const userData = getLocalStorageUserData();
  const [disabled, setDisabled] = useState(false);
  const dispatch = useDispatch();
  const toggleEditMode = (e) => {
    e.stopPropagation();
    setIsEditing(!isEditing);
  };

  const sanitizeTest = (fieldName) => ({
    name: `is-sanitized-${fieldName}`,
    test: (value) => {
      const sanitizedValue = sanitizeInput(value);
      return sanitizedValue === value; // Ensure input matches sanitized output
    },
    message: `Input should be sanitized, and no action should occur`,
  });
  const formik = useFormik({
    initialValues: {
      primary_holder_first_name:
        userGetProfile?.data?.user?.primary_holder_first_name || "",
      primary_holder_middle_name:
        userGetProfile?.data?.user?.primary_holder_middle_name || "",
      primary_holder_last_name:
        userGetProfile?.data?.user?.primary_holder_last_name || "",
      primary_holder_dob_incorporation:
        userGetProfile?.data?.user?.primary_holder_dob_incorporation || "",
      email: userGetProfile?.data?.user?.user?.email || "",
      // email_relation: userGetProfile?.data?.user?.profile?.email_relation || "",
      mobile_no: userGetProfile?.data?.user?.user?.mobile || "",
      // mobile_relation:
      //   userGetProfile?.data?.user?.profile?.mobile_relation || "",
      gender: userGetProfile?.data?.user?.gender || "",
      holding_nature: "SI",
      // father_name: userGetProfile?.data?.user?.profile?.father_name || "",
      occupation_code: userGetProfile?.data?.user?.occupation_code || "",
      primary_holder_pan: userGetProfile?.data?.user?.primary_holder_pan || "",
      // adhaar_card: userGetProfile?.data?.user?.profile?.adhaar_card || "",
      address_1: userGetProfile?.data?.user?.address_1 || "",
      pincode: userGetProfile?.data?.user?.pincode || "",
      city: userGetProfile?.data?.user?.city || "",
      state: userGetProfile?.data?.user?.state || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      primary_holder_first_name: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("First Name"))
        .matches(
          /^(?!\s*$)[A-Za-z\s]+$/,
          "First Name must contain only alphabets."
        )
        .required("First Name is required"),

      // primary_holder_middle_name: Yup.string()
      //   .transform((value) => value?.trim())
      //   .test(sanitizeTest("Middle Name"))
      //   .matches(
      //     /^(?!\s*$)[A-Za-z\s]+$/,
      //     "Middle Name must contain only alphabets."
      //   )
      //   .required("Middle Name is required"),

      primary_holder_last_name: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("Last Name"))
        .matches(
          /^(?!\s*$)[A-Za-z\s]+$/,
          "Last Name must contain only alphabets."
        )
        .required("Last Name is required"),
      primary_holder_dob_incorporation: Yup.date().required(
        "Date of Birth is required"
      ),
      email: Yup.string()
        .test(sanitizeTest("Email"))
        .email("Enter a valid email address.")
        .required("Email is required"),
      // email_relation: Yup.string()
      //   .notOneOf(["Select"], "Email Belongs To is required")
      //   .required("Email Belongs To is required"),
      mobile_no: Yup.string()
        .test(sanitizeTest("Mobile Number"))
        .matches(/^[6-9]\d{9}$/, "Mobile Number must be 10 digits")
        .required("Mobile Number is required"),
      // mobile_relation: Yup.string()
      //   .notOneOf(["Select"], "Mobile Belongs To is required")
      //   .required("Mobile Belongs To is required"),
      gender: Yup.string().required("Gender is required"),
      occupation_code: Yup.string()
        .notOneOf(["Select"], "Occupation is required")
        .required("Occupation is required"),
      holding_nature: Yup.string().required("Holding Nature is required"),
      // father_name: Yup.string()
      //   .test(sanitizeTest("Parent Name"))
      //   .matches(/^[A-Za-z\s]+$/, "Parent Name must contain only alphabets")
      //   .required("Parent Name is required"),
      primary_holder_pan: Yup.string()
        .test(sanitizeTest("PAN"))
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN Details")
        .required("PAN is required"),
      // adhaar_card: Yup.string()
      //   .test(sanitizeTest("Aadhar Number"))
      //   .matches(/^\d{12}$/, "Aadhar Number must be 12 digits")
      //   .required("Aadhar Number is required"),
      address_1: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("Address"))
        .max(200, "Input should not accept more than 200 characters")
        .required("Address is required"),
      pincode: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("Pincode"))
        .matches(/^\d{6}$/, "Pincode must be 6 digits")
        .required("Pincode is required"),
      city: Yup.string()
        .transform((value) => value?.trim())
        .test(sanitizeTest("City"))
        .required("City is required"),
      state: Yup.string()
        .transform((value) => value?.trim())
        .notOneOf(["Select"], "State is required")
        .required("State is required"),
    }),
    onSubmit: (values) => {
      setDisabled(true);
      const formatDate = convertDateToDDMMMYYYYLetter(
        values?.primary_holder_dob_incorporation
      );
      const payload = {
        ...values,
        primary_holder_dob_incorporation: formatDate,
        address_1: values?.address_1?.trim(),
      };
      dispatch(userPofileUpdate(payload)).then((res) => {
        setIsEditing(false);
        setDisabled(false);
      });
    },
  });
  console.log("formikformik", formik);

  const genderOptions = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "O", label: "Other" },
  ];

  const maritalOptions = [
    { value: "JO", label: "Joint" },
    { value: "SI", label: "Single" },
    { value: "AS", label: "Anyone Or Survivor" },
  ];
  const relationLabel = (email_relation) => {
    return Object.keys(userGetProfile?.data?.mobile_email_relations || {})
      .filter((key) => key === email_relation) // Match the specific email_relation
      .map((key) => userGetProfile?.data?.mobile_email_relations[key]); // Return the label
  };
  const getGenderLabel = (value) => {
    const option = genderOptions.find((option) => option.value === value);
    return option ? option.label : null; // Return label or null if not found
  };
  const getMaritalLabel = (value) => {
    const option = maritalOptions.find((option) => option.value === value);
    return option ? option.label : null; // Return label or null if not found
  };
  const getOccupationLabel = (value) => {
    const option = userGetProfile?.data?.occupations?.find(
      (option) => option.occupation_code == value
    );
    return option ? option.occupation_name : null; // Return label or null if not found
  };
  const getStateLabel = (value) => {
    const option = userGetProfile?.data?.states?.find(
      (option) => option.state_code === value
    );
    return option ? option.state_name : null; // Return label or null if not found
  };

  const callStateAndDistrict = async (pin) => {
    try {
      if (pin?.split("")?.length == 6) {
        const payload = {
          pincode: pin,
        };
        dispatch(pincode(payload))
          .then((res) => {
            formik?.setFieldValue(
              "city",
              res?.data?.data?.city ? res?.data?.data?.city : ""
            );
            formik?.setFieldValue(
              "state",
              res?.data?.data?.state_code ? res?.data?.data?.state_code : ""
            );
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  };
  return (
    <div className="accordion-item">
      <h2 className="accordion-header profile_header" id="headingTwo">
        <button
          className="accordion-button collapsed px-lg-4 px-md-4 px-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img
                src={my_profile123}
                alt=""
                className="personel_details_img"
              />
              {isEditing ? (
                <>
                  <span className="personal_inner_text">
                    Personal Details Edit
                  </span>
                </>
              ) : (
                <>
                  <span className="personal_inner_text">Personal Details</span>
                </>
              )}
            </div>
          </div>
        </button>
      </h2>

      <div
        id="collapseTwo"
        className="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
      >
        <hr className="m-0" />

        <div className="accordion-body profile_accordion_body">
          <div className="d-flex justify-content-end align-items-right">
            <div className="edit_personel">
              <span
                className="badge editBadge profile-mr"
                onClick={toggleEditMode}
              >
                {isEditing ? (
                  <>
                    <img src={view} alt="View Icon" className="pen_image" />
                    <span className="editInner d-sm-block d-none">View</span>
                  </>
                ) : (
                  <>
                    <img src={pen} alt="Edit Icon" className="pen_image" />
                    <span
                      className="editInner d-sm-block d-none"
                      onClick={() => {
                        formik.setFieldValue(
                          "primary_holder_first_name",
                          userGetProfile?.data?.user
                            ?.primary_holder_first_name || ""
                        );
                        formik.setFieldValue(
                          "primary_holder_middle_name",
                          userGetProfile?.data?.user
                            ?.primary_holder_middle_name || ""
                        );
                        formik.setFieldValue(
                          "primary_holder_last_name",
                          userGetProfile?.data?.user
                            ?.primary_holder_last_name || ""
                        );
                        formik.setFieldValue(
                          "primary_holder_dob_incorporation",
                          userGetProfile?.data?.user
                            ?.primary_holder_dob_incorporation || ""
                        );
                        formik.setFieldValue(
                          "email",
                          userGetProfile?.data?.user?.user?.email || ""
                        );
                        // formik.setFieldValue("email_relation", userGetProfile?.data?.user?.profile?.email_relation || "");
                        formik.setFieldValue(
                          "mobile_no",
                          userGetProfile?.data?.user?.user?.mobile || ""
                        );
                        // formik.setFieldValue("mobile_relation", userGetProfile?.data?.user?.profile?.mobile_relation || "");
                        formik.setFieldValue(
                          "gender",
                          userGetProfile?.data?.user?.gender || ""
                        );
                        // formik.setFieldValue("holding_nature", "SI");
                        // formik.setFieldValue("father_name", userGetProfile?.data?.user?.profile?.father_name || "");
                        formik.setFieldValue(
                          "occupation_code",
                          userGetProfile?.data?.user?.occupation_code || ""
                        );
                        formik.setFieldValue(
                          "primary_holder_pan",
                          userGetProfile?.data?.user?.primary_holder_pan || ""
                        );
                        // formik.setFieldValue("adhaar_card", userGetProfile?.data?.user?.profile?.adhaar_card || "");
                        formik.setFieldValue(
                          "address_1",
                          userGetProfile?.data?.user?.address_1 || ""
                        );
                        formik.setFieldValue(
                          "pincode",
                          userGetProfile?.data?.user?.pincode || ""
                        );
                        formik.setFieldValue(
                          "city",
                          userGetProfile?.data?.user?.city || ""
                        );
                        formik.setFieldValue(
                          "state",
                          userGetProfile?.data?.user?.state || ""
                        );
                      }}
                    >
                      Edit
                    </span>
                  </>
                )}
              </span>
            </div>
          </div>

          {/* Edit Personal Details Content */}

          {isEditing ? (
            <>
              <div className="card redeam_bottom_card">
                <div className="row form_body justify-content-center">
                  <div className="col-xl-8 col-lg-10 col-md-11 ">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            First Name <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="primary_holder_first_name"
                            placeholder="Enter Full Name"
                            {...formik.getFieldProps(
                              "primary_holder_first_name"
                            )}
                          />
                          {formik.touched.primary_holder_first_name &&
                            formik.errors.primary_holder_first_name && (
                              <div className="text-danger">
                                {formik.errors.primary_holder_first_name}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Father/Husband Name{" "}
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="primary_holder_middle_name"
                            placeholder="Enter Full Name"
                            {...formik.getFieldProps(
                              "primary_holder_middle_name"
                            )}
                          />
                          {/* {formik.touched.primary_holder_middle_name &&
                            formik.errors.primary_holder_middle_name && (
                              <div className="text-danger">
                                {formik.errors.primary_holder_middle_name}
                              </div>
                            )} */}
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Last Name <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="primary_holder_last_name"
                            placeholder="Enter Full Name"
                            {...formik.getFieldProps(
                              "primary_holder_last_name"
                            )}
                          />
                          {formik.touched.primary_holder_last_name &&
                            formik.errors.primary_holder_last_name && (
                              <div className="text-danger">
                                {formik.errors.primary_holder_last_name}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Date of Birth <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <DatePickerInput
                            selectedDate={
                              formik.values.primary_holder_dob_incorporation
                            }
                            maxDate={new Date().toISOString().split("T")[0]}
                            onChange={(date) =>
                              formik.setFieldValue(
                                "primary_holder_dob_incorporation",
                                date
                              )
                            }
                            disable="true"
                          />
                          {formik.touched.primary_holder_dob_incorporation &&
                            formik.errors.primary_holder_dob_incorporation && (
                              <div className="text-danger">
                                {formik.errors.primary_holder_dob_incorporation}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Email <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="anandr@gmail.com"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "email",
                                e.target.value.toLowerCase()
                              )
                            }
                            {...formik.getFieldProps("email")}
                          />
                          {formik.touched.email && formik.errors.email && (
                            <div className="text-danger">
                              {formik.errors.email}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Email Belongs to{" "}
                            <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <SelectDropDown
                            name="email_relation"
                            id=""
                            value={formik.values.email_relation}
                            changeFunction={(value) =>
                              formik?.setFieldValue("email_relation", value)
                            }
                            options={Object.keys(
                              userGetProfile?.data?.mobile_email_relations
                            )?.map((key) => ({
                              value: key,
                              label:
                                userGetProfile?.data?.mobile_email_relations[
                                  key
                                ],
                            }))}
                            {...formik.getFieldProps("email_relation")}
                          />
                          {formik.touched.email_relation &&
                            formik.errors.email_relation && (
                              <div className="text-danger">
                                {formik.errors.email_relation}
                              </div>
                            )}
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Mobile Number <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="mobile_no"
                            placeholder="Mobile Number"
                            {...formik.getFieldProps("mobile_no")}
                          />
                          {formik.touched.mobile_no &&
                            formik.errors.mobile_no && (
                              <div className="text-danger">
                                {formik.errors.mobile_no}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Mobile Number Belongs to{" "}
                            <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <SelectDropDown
                            name="mobile_relation"
                            id=""
                            value={formik.values.mobile_relation}
                            changeFunction={(value) =>
                              formik?.setFieldValue("mobile_relation", value)
                            }
                            options={Object.keys(
                              userGetProfile?.data?.mobile_email_relations
                            ).map((key) => ({
                              value: key,
                              label:
                                userGetProfile?.data?.mobile_email_relations[
                                  key
                                ],
                            }))}
                          />
                          {formik.touched.mobile_relation &&
                            formik.errors.mobile_relation && (
                              <div className="text-danger">
                                {formik.errors.mobile_relation}
                              </div>
                            )}
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Gender <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <div class="d-flex align-items-center gap-2 flex-wrap">
                            {genderOptions.map(({ value, label }) => (
                              <div
                                className="form-check form-check-inline"
                                key={value}
                              >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  id={value}
                                  value={value}
                                  onChange={formik.handleChange}
                                  checked={formik.values.gender === value}
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor={value}
                                >
                                  {label}
                                </label>
                              </div>
                            ))}
                          </div>
                          {formik.touched.gender && formik.errors.gender ? (
                            <div className="text-danger">
                              {formik.errors.gender}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Holding Nature <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <div class="d-flex align-items-center gap-2 flex-wrap">
                            {maritalOptions.map(({ value, label }) => (
                              <div
                                className="form-check form-check-inline"
                                key={value}
                              >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="holding_nature"
                                  id={value}
                                  value={value}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.holding_nature === value
                                  }
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor={value}
                                >
                                  {label}
                                </label>
                              </div>
                            ))}
                          </div>
                          {formik.touched.holding_nature &&
                          formik.errors.holding_nature ? (
                            <div className="text-danger">
                              {formik.errors.holding_nature}
                            </div>
                          ) : null}
                        </div>
                      </div> */}

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Father/Husband Name{" "}
                            <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="father_name"
                            placeholder="Enter Father/Husband Name"
                            value=""
                            {...formik.getFieldProps("father_name")}
                          />
                          {formik.touched.father_name &&
                            formik.errors.father_name && (
                              <div className="text-danger">
                                {formik.errors.father_name}
                              </div>
                            )}
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Occupation <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <SelectDropDown
                            name="occupation_code"
                            id=""
                            value={formik?.values?.occupation_code}
                            changeFunction={(value) =>
                              formik?.setFieldValue("occupation_code", value)
                            }
                            options={userGetProfile?.data?.occupations.map(
                              (occ) => ({
                                value: occ.occupation_code,
                                label: occ.occupation_name,
                              })
                            )}
                          />
                          {formik.touched.occupation_code &&
                            formik.errors.occupation_code && (
                              <div className="text-danger">
                                {formik.errors.occupation_code}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            PAN <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="primary_holder_pan"
                            placeholder="Enter Pan"
                            disabled={true}
                            {...formik.getFieldProps("primary_holder_pan")}
                          />
                          {formik.touched.primary_holder_pan &&
                            formik.errors.primary_holder_pan && (
                              <div className="text-danger">
                                {formik.errors.primary_holder_pan}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Aadhar Number <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="adhaar_card"
                            placeholder="Enter Aadhar Number"
                            {...formik.getFieldProps("adhaar_card")}
                          />
                          {formik.touched.adhaar_card &&
                            formik.errors.adhaar_card && (
                              <div className="text-danger">
                                {formik.errors.adhaar_card}
                              </div>
                            )}
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Address <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="address_1"
                            placeholder="Enter Address"
                            {...formik.getFieldProps("address_1")}
                          />
                          {formik.touched.address_1 &&
                            formik.errors.address_1 && (
                              <div className="text-danger">
                                {formik.errors.address_1}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            Pincode <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="pincode"
                            name="pincode"
                            placeholder="Enter Pincode"
                            onChange={(e) => {
                              formik.handleChange(e); // Handle Formik's change
                              callStateAndDistrict(e.target.value); // Call your custom function
                            }}
                            value={formik.values.pincode}
                          />
                          {formik.touched.pincode && formik.errors.pincode && (
                            <div className="text-danger">
                              {formik.errors.pincode}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            City <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            placeholder="Enter City"
                            {...formik.getFieldProps("city")}
                          />
                          {formik.touched.city && formik.errors.city && (
                            <div className="text-danger">
                              {formik.errors.city}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-xl-5 col-lg-6 col-md-6 col-sm-5">
                          <label className="form-label">
                            State <span className="red-color">*</span>
                          </label>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-6 col-sm-7">
                          <SelectDropDown
                            name="state"
                            id=""
                            value={formik?.values?.state}
                            changeFunction={(value) =>
                              formik?.setFieldValue("state", value)
                            }
                            options={userGetProfile?.data?.states.map(
                              (state) => ({
                                value: state.state_code,
                                label: state.state_name,
                              })
                            )}
                          />
                          {formik.touched.state && formik.errors.state && (
                            <div className="text-danger">
                              {formik.errors.state}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-center gap-2 mt-lg-5 mt-4">
                        <button
                          type="submit"
                          className="form_button next_btn"
                          disabled={disabled}
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* View Personal Details Content */}

              <div className="card redeam_bottom_card">
                <div className="row form_body justify-content-center">
                  <div className="col-xl-6 col-lg-10 col-md-10 ">
                    <form>
                      {/* <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Full Name:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{userGetProfile?.data?.user?.user?.name}</span>
                        </div>
                      </div> */}

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            First Name:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {
                              userGetProfile?.data?.user
                                ?.primary_holder_first_name
                            }
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Father/Husband Name:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {
                              userGetProfile?.data?.user
                                ?.primary_holder_middle_name 
                            }
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Last Name:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {
                              userGetProfile?.data?.user
                                ?.primary_holder_last_name
                            }
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Date of Birth:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {userGetProfile?.data?.user?.user?.dob &&
                              convertDateToDDMMYYYYStartWithYear(
                                userGetProfile?.data?.user?.user?.dob
                              )}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Email:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span className="white-space-nowrap">
                            {userGetProfile?.data?.user?.email}
                          </span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Email Belongs to:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {relationLabel(
                              userGetProfile?.data?.user?.profile
                                ?.email_relation
                            )}
                          </span>
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Mobile Number:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {userGetProfile?.data?.user?.user?.mobile}
                          </span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Mobile Number Belongs to:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {relationLabel(
                              userGetProfile?.data?.user?.profile
                                ?.mobile_relation
                            )}
                          </span>
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Gender:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {getGenderLabel(userGetProfile?.data?.user?.gender)}
                          </span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Holding Nature:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {getMaritalLabel(
                              userGetProfile?.data?.user?.holding_nature
                            )}
                          </span>
                        </div>
                      </div> */}

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Father/Husband Name:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {
                              userGetProfile?.data?.user
                                ?.primary_holder_middle_name
                            }
                          </span>
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Occupation:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {getOccupationLabel(
                              userGetProfile?.data?.user?.occupation_code
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            PAN:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{userGetProfile?.data?.user?.user?.pan}</span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Aadhar Number:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {userGetProfile?.data?.user?.profile?.adhaar_card}
                          </span>
                        </div>
                      </div> */}

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Address:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{userGetProfile?.data?.user?.address_1}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            Pincode:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{userGetProfile?.data?.user?.pincode}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            City:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{userGetProfile?.data?.user?.city}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-lg-6 col-md-6 col-sm-5 my-md-2 my-1">
                          <label className="form-label accordion-from-label">
                            State:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {getStateLabel(userGetProfile?.data?.user?.state)}
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonelDetail;
